// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trial-banner {
  background: #fff3cd;
  color: #111;
  font-size: 13px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 10px 5px;
  border: 1px solid #ffecb5;
  border-radius: 6px;
  flex-wrap: wrap;
  /* responsive */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.font-weight-600 {
  font-weight: 600;
}

.font-weight-500 {
  font-weight: 500;
}

.skip-container {
  display: flex;
  align-items: center;
  background: #ffe8a3;
  /* slightly darker yellow for contrast */
  padding: 6px 12px;
  border-radius: 2rem;
  border: 1px solid #d1b15f;
  gap: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.skip-left {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #111;
  font-size: 13px;
}

.skip-left .icon {
  font-size: 13px;
}

.skip-btn {
  background: #ffd76a !important;
  border: 1px solid #e0b94a !important;
  padding: 3px 12px;
  border-radius: 16px;
  font-size: 13px;
  color: #111 !important;
  font-weight: 500;
}

.skip-btn:hover {
  background: #ffcd4d !important;
}


/* -----------------------
   MOBILE VIEW (VERY IMPORTANT)
----------------------- */
@media (max-width: 850px) {
  .trial-banner {
    flex-direction: column;
    align-items: center;
  }
}

progress.usage-progress::-webkit-progress-bar {
  background-color: #e9ecef;
}


/* Success (green) */
progress.m--bg-brand::-webkit-progress-value {
  background-color: #716aca;
}

/* Warning (orange) */
progress.bg-warning::-webkit-progress-value {
  background-color: #ffb822;
}

/* Danger (red) */
progress.bg-danger::-webkit-progress-value {
  background-color: #f4516c;
}

/* Firefox */
progress.m--bg-brand::-moz-progress-bar {
  background-color: #716aca;
}

progress.bg-warning::-moz-progress-bar {
  background-color: #ffb822;
}

progress.bg-danger::-moz-progress-bar {
  background-color: #f4516c;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/trial-banner/trial-banner.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;;AAGA;;yBAEyB;AACzB;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".trial-banner {\n  background: #fff3cd;\n  color: #111;\n  font-size: 13px;\n  padding: 10px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 10px 5px;\n  border: 1px solid #ffecb5;\n  border-radius: 6px;\n  flex-wrap: wrap;\n  /* responsive */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n}\n\n.font-weight-600 {\n  font-weight: 600;\n}\n\n.font-weight-500 {\n  font-weight: 500;\n}\n\n.skip-container {\n  display: flex;\n  align-items: center;\n  background: #ffe8a3;\n  /* slightly darker yellow for contrast */\n  padding: 6px 12px;\n  border-radius: 2rem;\n  border: 1px solid #d1b15f;\n  gap: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n}\n\n.skip-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #111;\n  font-size: 13px;\n}\n\n.skip-left .icon {\n  font-size: 13px;\n}\n\n.skip-btn {\n  background: #ffd76a !important;\n  border: 1px solid #e0b94a !important;\n  padding: 3px 12px;\n  border-radius: 16px;\n  font-size: 13px;\n  color: #111 !important;\n  font-weight: 500;\n}\n\n.skip-btn:hover {\n  background: #ffcd4d !important;\n}\n\n\n/* -----------------------\n   MOBILE VIEW (VERY IMPORTANT)\n----------------------- */\n@media (max-width: 850px) {\n  .trial-banner {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\nprogress.usage-progress::-webkit-progress-bar {\n  background-color: #e9ecef;\n}\n\n\n/* Success (green) */\nprogress.m--bg-brand::-webkit-progress-value {\n  background-color: #716aca;\n}\n\n/* Warning (orange) */\nprogress.bg-warning::-webkit-progress-value {\n  background-color: #ffb822;\n}\n\n/* Danger (red) */\nprogress.bg-danger::-webkit-progress-value {\n  background-color: #f4516c;\n}\n\n/* Firefox */\nprogress.m--bg-brand::-moz-progress-bar {\n  background-color: #716aca;\n}\n\nprogress.bg-warning::-moz-progress-bar {\n  background-color: #ffb822;\n}\n\nprogress.bg-danger::-moz-progress-bar {\n  background-color: #f4516c;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
